/* lm-rotating-banner — cross-fade the home hero banners by toggling .is-active.
   The fade itself is a CSS opacity transition; this only swaps which slide is active,
   on a timer. Pauses when the tab is hidden; respects reduced-motion (no auto-rotate).
   Theme-editor aware: re-inits when the section reloads, and shows whichever banner block
   the merchant selects so they edit the slide they can see. */
(function () {
  'use strict';

  function activate(slides, n) {
    slides.forEach(function (s, k) {
      var on = k === n;
      s.classList.toggle('is-active', on);
      s.setAttribute('aria-hidden', on ? 'false' : 'true');
    });
  }

  function init(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('.lm-rbanner__slide'));
    // clear any previous timer (section can re-render in the editor)
    if (root._lmTimer) { clearInterval(root._lmTimer); root._lmTimer = null; }
    if (!slides.length) return;

    var delay = parseInt(root.getAttribute('data-delay'), 10) || 5300;
    var i = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
    if (i < 0) { i = 0; activate(slides, 0); }

    // hint the browser to fetch the next image just before it is needed
    function preload(n) {
      var img = slides[n] && slides[n].querySelector('img');
      if (img && img.getAttribute('loading') === 'lazy') img.setAttribute('loading', 'eager');
    }

    if (slides.length < 2) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    preload((i + 1) % slides.length);

    function next() {
      i = (i + 1) % slides.length;
      activate(slides, i);
      preload((i + 1) % slides.length);
    }

    root._lmTimer = setInterval(next, delay);
    document.addEventListener('visibilitychange', function () {
      if (!root._lmTimer && document.hidden) return;
      clearInterval(root._lmTimer);
      root._lmTimer = null;
      if (!document.hidden) root._lmTimer = setInterval(next, delay);
    });
  }

  function boot() {
    document.querySelectorAll('[data-lm-rbanner]').forEach(init);
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  /* ---- Theme editor niceties ---- */
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-lm-rbanner]');
    if (root) init(root);
  });
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:block:select', function (e) {
      var slide = e.target.closest && e.target.closest('.lm-rbanner__slide');
      if (!slide) return;
      var root = slide.closest('[data-lm-rbanner]');
      if (!root) return;
      var slides = Array.prototype.slice.call(root.querySelectorAll('.lm-rbanner__slide'));
      var n = slides.indexOf(slide);
      if (n < 0) return;
      // pause the auto-rotate while the merchant works on a specific slide, and show it
      if (root._lmTimer) { clearInterval(root._lmTimer); root._lmTimer = null; }
      activate(slides, n);
    });
    document.addEventListener('shopify:block:deselect', function (e) {
      var slide = e.target.closest && e.target.closest('.lm-rbanner__slide');
      if (slide) { var root = slide.closest('[data-lm-rbanner]'); if (root) init(root); }
    });
  }
})();
